import { render, staticRenderFns } from "./SettingPlayStyle.vue?vue&type=template&id=58becb88&scoped=true&"
import script from "./SettingPlayStyle.vue?vue&type=script&lang=js&"
export * from "./SettingPlayStyle.vue?vue&type=script&lang=js&"
import style0 from "./SettingPlayStyle.vue?vue&type=style&index=0&id=58becb88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58becb88",
  null
  
)

export default component.exports